import React, { useState, useEffect } from "react";

const ExperienceModal = ({ content, onClose, onSelection }) => {
  const { text, skills, areaIndex } = content;
  const [localSkills, setLocalSkills] = useState(skills);

  useEffect(() => {
    setLocalSkills(skills);
  }, [skills]);

  const toggleSkillSelection = (skillIndex, selectionType) => {
    const updatedSkills = localSkills.map((skill, index) => {
      if (index === skillIndex) {
        return {
          ...skill,
          [selectionType]: !skill[selectionType],
        };
      }
      return skill;
    });

    setLocalSkills(updatedSkills);

    onSelection({ areaIndex, updatedSkills });
  };

  const handleCloseModal = () => {
    onClose(areaIndex);
  };

  return (
    <div className="experience-modal-background">
      <div
        className="experience-modal-container"
        onClick={(e) => e.stopPropagation()}
      >
        <button onClick={handleCloseModal} className="experience-close-modal">
          X
        </button>
        <h4>{text}</h4>

        <div className="experience-modal-header">
          <span>Select your experience for the skills below:</span>
        </div>
        <div className="experience-modal-content">
          {localSkills.map((skill, index) => (
            <div key={index} className="experience-skill-row">
              <div className="experience-skill-name">{skill.name}</div>
              <div className="experience-skill-options">
                <button
                  className={`experience-skill-button ${
                    skill.professional ? "selected" : ""
                  }`}
                  onClick={() => toggleSkillSelection(index, "professional")}
                >
                  Professional
                </button>
                <button
                  className={`skill-button ${skill.personal ? "selected" : ""}`}
                  onClick={() => toggleSkillSelection(index, "personal")}
                >
                  Personal
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ExperienceModal;
